import React from "react";
import { ConfirmDialog, useNotifications } from "sprint-common-web";

import { useCloudFileApi } from "../../../../../common/api/master-api/cloud-files/useCloudFileApi";

interface CopyCloudFileToUploadDialogProps {
    cloudAssetId: string;
    isOpen: boolean;
    onClose(): void;
}

export const CopyCloudFileToUploadDialog = ({
    cloudAssetId,
    isOpen,
    onClose
}: CopyCloudFileToUploadDialogProps): JSX.Element => {
    const { copyCloudFileToUpload } = useCloudFileApi();

    const { success, error } = useNotifications();

    const handleConfirm = async () => {
        try {
            await copyCloudFileToUpload({ assetId: cloudAssetId });

            success("Cloud file successfully sent to upload bucket");
        } catch (e) {
            error("Something went wrong while sending cloud file to upload bucket");
        } finally {
            handleClose();
        }
    };

    const handleClose = () => {
        onClose();
    };

    return (
        <ConfirmDialog
            width={"40%"}
            title="Copy cloud file"
            text="Are you sure you want to copy the cloud file back to the upload bucket?"
            hidden={!isOpen}
            confirm={{ onClick: handleConfirm }}
            cancel={{ onClick: handleClose }}
        />
    );
};
